export default __webpack_public_path__ + "static/media/ALESAN.c2749b9f.svg";